"use client";

export default function SuitPreview({ color = "#334155" }) {
  return (
    <div className="relative w-full max-w-md mx-auto aspect-[3/4] bg-slate-50 rounded-2xl flex items-center justify-center p-8 border border-slate-200 shadow-inner">
      {/* This SVG represents the "Fabric" of the suit */}
      <svg 
        viewBox="0 0 200 300" 
        className="absolute w-full h-full p-12 transition-colors duration-700 ease-in-out"
        style={{ fill: color }}
      >
        {/* Simple Suit Silhouette Path */}
        <path d="M40,50 L160,50 L180,280 L20,280 Z" /> 
      </svg>

      {/* This image is the "Line Art" (The details like buttons/lapels) */}
      {/* You can replace this with a real transparent PNG of a suit outline later */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <span className="text-slate-300 font-bold uppercase tracking-widest opacity-30 text-5xl rotate-12">
          Alshakilee
        </span>
      </div>
      
      <div className="absolute bottom-6 left-6">
        <p className="text-[10px] uppercase tracking-widest text-slate-400 font-bold">Visualization Only</p>
      </div>
    </div>
  );
}